var _defs, _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgG10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.945,
    height: 80.947,
    viewBox: "0 0 80.945 80.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.945,
    height: 80.947,
    transform: "translate(0 0)",
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80.945,
    height: 80.947,
    transform: "translate(0 0)",
    fill: "#de1266"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81,10.606V23.112h2.747V6.774H8.364L5.834,9.739v2.868h.023l1.928-2Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.207,19.329V10.557c0-.988.361-1.687,1.3-1.687.964,0,1.325.7,1.325,1.687v8.772c0,.988-.361,1.685-1.325,1.685-.94,0-1.3-.7-1.3-1.685M20.58,18.9V10.99c0-2.554-1.277-4.409-4.072-4.409-2.771,0-4.049,1.855-4.049,4.409V18.9c0,2.529,1.278,4.409,4.049,4.409,2.8,0,4.072-1.88,4.072-4.409",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.969,7.687V9.778h.376a.489.489,0,0,0,.555-.555V8.232c0-.367-.168-.545-.555-.545Zm0,2.715v3.082h-1.13V6.766h1.645c1.14,0,1.556.564,1.556,1.506v.862c0,.723-.258,1.149-.9,1.3l1.08,3.052H28.029Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.753,6.765h2.695v.922H30.883V9.609H32v.911H30.883v2.042h1.565v.921H29.753Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.757,12.562c.466,0,.644-.277.644-.684V8.361a.589.589,0,0,0-.644-.674h-.475v4.875Zm1.774-3.993V11.68c0,1.031-.426,1.8-1.635,1.8H33.152V6.766H34.9c1.209,0,1.635.762,1.635,1.8",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.554,6.765v5.083c0,1.041-.446,1.714-1.6,1.714a1.516,1.516,0,0,1-1.685-1.714V6.765H38.4v5.192c0,.4.159.664.555.664s.555-.267.555-.664V6.765Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3,11.75V8.5a1.584,1.584,0,0,1,1.684-1.813c1.248,0,1.6.693,1.6,1.684v.793H43.546V8.282c0-.416-.137-.654-.544-.654s-.575.287-.575.694v3.606c0,.407.168.694.575.694s.544-.258.544-.654V10.729h1.031v1.16c0,.961-.4,1.674-1.6,1.674A1.588,1.588,0,0,1,41.3,11.75",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.291,6.765h2.695v.922H46.421V9.609H47.54v.911H46.421v2.042h1.565v.921H45.291Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.295,12.562c.466,0,.644-.277.644-.684V8.361a.589.589,0,0,0-.644-.674H49.82v4.875Zm1.774-3.993V11.68c0,1.031-.426,1.8-1.635,1.8H48.69V6.766h1.744c1.209,0,1.635.762,1.635,1.8",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.13,
    height: 6.718,
    transform: "translate(25.836 16.383)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.651,18.88V23.1H27.7V16.383h1.11l1.218,3.854V16.383h.942V23.1h-.991Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.613,16.383h2.695V17.3H32.743v1.922h1.119v.911H32.743V22.18h1.565V23.1H31.613Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.014,21.6V17.939c0-.407-.179-.694-.585-.694s-.575.287-.575.694V21.6c0,.4.179.693.575.693s.585-.3.585-.693m-1,1.952V23.1a1.545,1.545,0,0,1-1.289-1.734v-3.25a1.712,1.712,0,1,1,3.418,0v3.25a1.615,1.615,0,0,1-.832,1.586l.832.158v.842Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.057,16.383v5.083c0,1.041-.446,1.714-1.595,1.714a1.516,1.516,0,0,1-1.685-1.714V16.383h1.13v5.192c0,.4.159.664.555.664s.555-.267.555-.664V16.383Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.831,20.971h.9l-.446-2.7h-.01ZM42.414,23.1l1.268-6.718h1.289L46.249,23.1H45.09l-.209-1.229h-1.2l-.2,1.229Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.715,16.383h1.13v5.8h1.347V23.1H46.715Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.13,
    height: 6.718,
    transform: "translate(49.697 16.383)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.342,16.383h3V17.3h-.931v5.8h-1.14V17.3h-.931Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.13,
    height: 6.718,
    transform: "translate(54.87 16.383)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.643,16.383h2.695V17.3H57.773v1.922h1.119v.911H57.773V22.18h1.565V23.1H56.643Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.785,21.654v-.9h1.049v.922c0,.376.169.594.555.594.357,0,.516-.237.516-.594v-.258a1.214,1.214,0,0,0-.506-.951l-.664-.664a2.266,2.266,0,0,1-.941-1.794V17.78A1.4,1.4,0,0,1,61.379,16.3c1.13,0,1.576.555,1.576,1.526v.545H61.924V17.79c0-.387-.178-.575-.535-.575a.5.5,0,0,0-.535.555v.139c0,.376.209.594.535.911l.724.713a2.258,2.258,0,0,1,.911,1.745V21.6a1.455,1.455,0,0,1-1.645,1.576,1.4,1.4,0,0,1-1.594-1.526",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.671,43.837l7.252,7.252-7.252,7.252Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.454,43.837,20.2,51.089l7.252,7.252Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.454,38.338l7.252-7.252,7.252,7.252Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.077,64.281l7.252,7.252,7.252-7.252Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.745,
    height: 4.266,
    transform: "translate(32.845 44.444)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.745,
    height: 4.266,
    transform: "translate(32.845 53.741)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG10);
export default __webpack_public_path__ + "static/media/G10.1f17e913852b5acac55a19fbf6160129.svg";
export { ForwardRef as ReactComponent };